import i18n from 'i18n'
import * as React from "react"
import { SelectAjaxSeeker } from "ui-seeker/core"
import { FORM_URL } from 'app/@common/constants'

export default function SelectLocationAccommodation({...props}) {

    const myProps = {
        urlAjax: FORM_URL.LOCATION_ACCOMMODATION,
        placeholder: i18n.t('common:filters.accommodationType'),
        icon: {icon: 'bed'},
        isMulti: false,
        ...props
    }

    return <SelectAjaxSeeker {...myProps} />
}
